import React from 'react'
import { Link } from 'react-router'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import * as s from './PublicAccountShell.scss'

const PublicAccountShell = ({ eyebrow, title, description, icon, children, footer = null }) => (
    <main className={s.page}>
        <div className={s.shell}>
            <aside className={s.introPanel}>
                <Link className={s.backLink} to='/'>
                    <FontAwesomeIcon name='arrow-left' /> Back to home
                </Link>
                <div className={s.introContent}>
                    <span className={s.icon}><FontAwesomeIcon name={icon} /></span>
                    <div className={s.eyebrow}>{eyebrow}</div>
                    <h1>{title}</h1>
                    <p>{description}</p>
                </div>
                <div className={s.introFooter}>
                    <FontAwesomeIcon name='shield-alt' />
                    <span>Your account information stays private and secure.</span>
                </div>
            </aside>
            <section className={s.formPanel}>
                <div className={s.formContent}>{children}</div>
                {footer ? <div className={s.formFooter}>{footer}</div> : null}
            </section>
        </div>
    </main>
)

export default PublicAccountShell
